// src/utils/estimateLineTax.js — taxpick4-54573069 (tax codes on every line, Stage S4: the estimate page)
//
// The estimate page's tax, when the company's Settings › Taxes switch is ON.
// taxlines5-a4c81e37 — Stage S5 moved the rules into src/utils/documentLineTax.js (every web editor
// shares them: the estimate page and the four older pop-ups); this file re-exports them unchanged,
// plus the one estimate-only step below (the catalog panel / quick add's "Add").
import { TAX_MODES, withItemSalesTax } from './documentLineTax';
import { appendPickedEstimateLines } from './catalogPickLines';

export * from './documentLineTax';
export const TAX_PICK_MARKER = 'taxpick4-54573069';

/** The catalog panel / quick add's "Add": today's append, then each new line takes its item's code. */
export function appendPicksWithTax(lines, picks, ids, ctx) {
    const out = appendPickedEstimateLines(lines, picks, ids);
    if (ctx.mode !== TAX_MODES.NAMED || !picks.length) return out;
    const first = out.length - picks.length;
    return out.map((l, i) => (i >= first ? withItemSalesTax(l, picks[i - first].item, ctx) : l));
}
